export type ContactSubmissionInput = {
  email?: unknown;
  topic?: unknown;
  message?: unknown;
  turnstileToken?: unknown;
  website?: unknown;
};

export const contactTopics = ["Sales Inquiry", "General Inquiry", "Report Abuse", "Other Questions"] as const;

export type ContactTopic = (typeof contactTopics)[number];

type ContactSubmission =
  | {
      ok: true;
      data: {
        email: string;
        topic: ContactTopic;
        message: string;
        turnstileToken: string;
      };
    }
  | {
      ok: false;
      error: string;
    };

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateContactSubmission(input: ContactSubmissionInput): ContactSubmission {
  const email = typeof input.email === "string" ? input.email.trim() : "";
  const topic = typeof input.topic === "string" ? input.topic.trim() : "";
  const message = typeof input.message === "string" ? input.message.trim() : "";
  const turnstileToken = typeof input.turnstileToken === "string" ? input.turnstileToken.trim() : "";
  const website = typeof input.website === "string" ? input.website.trim() : "";

  if (website) {
    return { ok: false, error: "Unable to submit this message." };
  }

  if (!emailPattern.test(email) || email.length > 254) {
    return { ok: false, error: "Enter a valid email address." };
  }

  if (!contactTopics.includes(topic as ContactTopic)) {
    return { ok: false, error: "Choose a topic." };
  }

  if (message.length < 10) {
    return { ok: false, error: "Message must be at least 10 characters." };
  }

  if (message.length > 4000) {
    return { ok: false, error: "Message must be 4000 characters or fewer." };
  }

  if (!turnstileToken || turnstileToken.length > 2048) {
    return { ok: false, error: "Please complete the security check." };
  }

  return {
    ok: true,
    data: {
      email,
      topic: topic as ContactTopic,
      message,
      turnstileToken,
    },
  };
}
